module.exports = __webpack_public_path__ + "img/cursor3.43b5ebd9.png";